<template>
<div class="cta_subscribe">
    <div class="container-fluid h-100">
        <div class="container">
            <div class="row h-100 justify-content-center align-items-center">
                <div class="col-md-12 p-0">
                    <div class="block_1">
                        <figure><img src="../assets/img/doctors_icon.svg" alt=""></figure>
                        <h3>¿SOS MÉDICO?</h3>
                        <p>
                            Nuestro servicio está pensado para hacer crecer tu consulta privada y captar nuevos pacientes. <br>
                            Manejá tu agenda según tu disponibilidad y administrá tus consultas de una manera simple y rápida. 
                        </p>
                        <a href="https://medicos.doctorconsultas.com/register" class="btn_1">Registrate ahora</a>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: 'HomeMedicRegister',
    components: {
    }
}
</script>

<style scoped>
.cta_subscribe {
    background: url(../assets/img/medic-area.jpg);
    background-size: cover;
    /* Create the parallax scrolling effect */
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

}
.cta_subscribe .block_1 {
    padding: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    color: #fff;
}

.cta_subscribe h3 {
    color: #fff;
    font-size: 26px;
    font-size: 1.625rem;
    font-weight: 400;
    letter-spacing: -1px;
    text-transform: uppercase;
}

.cta_subscribe p {
    font-size: 16px;
    font-size: 1rem;
}

.cta_subscribe a.btn_1, .cta_subscribe .btn_1 {
    border: none;
    color: #fff;
    width: 180px;
    background: #74d1c6;
    outline: none;
    cursor: pointer;
    display: inline-block;
    margin: 15px auto 0;
    text-decoration: none;
    padding: 15px 30px;
    color: #fff;
    font-weight: 600;
    text-align: center;
    line-height: 1;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    font-size: 14px;
    font-size: 0.875rem;
}

.btn_1{
  background-color:#768488 !important;
}
.btn_1:hover,.btn_1:active{
  background-color:#12bcec !important;
}
</style>
